import { render } from "./ConfirmOrder.vue?vue&type=template&id=0f127a6b&scoped=true"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js"

import "./ConfirmOrder.vue?vue&type=style&index=0&id=0f127a6b&lang=scss&scoped=true"
import "./ConfirmOrder.vue?vue&type=style&index=1&id=0f127a6b&lang=scss"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f127a6b"]])

export default __exports__